import { Component, NgZone, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormControl, Validators } from '@angular/forms';
import { ListCompanies } from '../models/company.model';
import { UserElement, RolElement } from './../models/user.model';
import { CompanyService } from './../services/company.service';
import { UserService } from '../services/user.service';
import { LanguageService } from '../services/language.service';
import { MenusComponent } from './../menus/menus.component';
import { DialogService } from '../services/dialog.service';
import { TranslocoService } from '@jsverse/transloco';
import { StorageService } from '../services/storage.service';

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrl: './user.component.css'
})

export class UserComponent implements OnInit {

  constructor(public ngZone: NgZone, private router: Router, private route: ActivatedRoute,
              private companyService: CompanyService, private userService: UserService,
              private menusComponent: MenusComponent, private dialogService: DialogService,
              private langService: LanguageService, private translocoService: TranslocoService,
              public storageService: StorageService) { }

  public titleUser = "Usuario";
  public new = false;
  @Input() id: number=0;
  companyId: number=0;
  rolControl = new FormControl('', [Validators.required]);
  companyControl = new FormControl('', [Validators.required]);

  lstCompanies: ListCompanies[] = [];
  lstRoles: RolElement[] = [];
  item: any = [];

  pathId: number=0;

  first_name_Input:string="";
  last_name_Input:string="";
  email_Input:string="";
  password_hash_Input:string="";
  new_password_hash_Input:string="";
  new_password_hash_Input2:string="";
  rol_Selected:number=0;
  company_Selected:number=0;
  confirmed_Checked:boolean=false;
  passwordsDoNotMatch: boolean = false;

  user: UserElement = {
    id: 0,
    confirmed: false,
    first_name: '',
    last_name: '',
    email: '',
    password: '',
    password_hash: '',
    new_password_hash: '',
    new_password_hash2: '',
    role_id: 0,
    company_id: 0,
  }

  ngOnInit(): void {
    this.route.queryParams.
      subscribe(params => {
        this.id = (params['id']);
        this.companyId = (params['company_id']) || this.storageService.companyId;
      });

    const currentLang = this.langService.getLang();
    if(this.id > 0){
      this.new = false
      this.translocoService.selectTranslate('user.titleEdit')
      .subscribe((translatedTitle: string) => {
        this.titleUser = translatedTitle;
      });

      //GET
      const req=this.userService.getUserById(this.id, this.companyId);
      req.subscribe({
        next: (res) => {
          this.item = res;
          if(this.item.data != null){
            this.first_name_Input = this.item.data.first_name;
            this.last_name_Input = this.item.data.last_name;
            this.email_Input = this.item.data.email;
            this.password_hash_Input = '';
            this.rol_Selected = this.item.data.role_id;
            this.company_Selected = this.item.data.company_id;
            this.companyId = this.item.data.company_id;
            this.confirmed_Checked = this.item.data.confirmed;
          }
        },
        error: (e) => {
          console.error(e);
          let msg = e.error.message;
        },
      });

    }else{
      this.new = true
      this.company_Selected = this.storageService.companyId
      this.companyId = this.storageService.companyId
      this.translocoService.selectTranslate('user.titleNew')
      .subscribe((translatedTitle: string) => {
        this.titleUser = translatedTitle;
      });

    }

    this.lstRoles=this.userService.getRolesListByRole(this.storageService.roleId,
                                                      this.companyId);

    this.lstCompanies=this.companyService.getCompaniesListByRol(this.storageService.roleId,
                                                                this.companyId);
  }

  onGuardarItm(){
    if ( !(this.company_Selected>0) || !(this.rol_Selected>0) ){
      console.log(this.company_Selected)
      return;
    }
    let msg:string="";
    this.checkPasswords()
    if (this.new ){
      //ADD
      this.user = {
        id: 0,
        confirmed: this.confirmed_Checked,
        first_name: this.first_name_Input,
        last_name: this.last_name_Input,
        email: this.email_Input,
        password: this.password_hash_Input,
        password_hash: this.password_hash_Input,
        new_password_hash: '',
        new_password_hash2: '',
        role_id: this.rol_Selected,
        company_id: this.company_Selected,
      }
      this.userService.addUser(this.user, this.companyId)
      .subscribe({
        next: (res) => {
          msg = res.message;
          console.log(msg);
          this.msgDialog(msg, '', true, 'O');
        },
        error: (e) => {
          msg = e.error.message;
          console.error(e);
          this.msgDialog('ERROR', msg, false, 'E');
        },
      });
    }else if(!this.passwordsDoNotMatch){
      //UPDATE
      this.user = {
        id: this.id,
        confirmed: this.confirmed_Checked,
        first_name: this.first_name_Input,
        last_name: this.last_name_Input,
        email: this.email_Input,
        password: this.password_hash_Input,
        password_hash: this.password_hash_Input,
        new_password_hash: this.new_password_hash_Input,
        new_password_hash2: this.new_password_hash_Input2,
        role_id: this.rol_Selected,
        company_id: this.company_Selected,
      }
      this.userService.updateUser(this.id, this.user, this.companyId)
      .subscribe({
        next: (res) => {
          msg = res.message;
          console.log(msg);
          this.msgDialog(msg, '', true, 'O');
        },
        error: (e) => {
          msg = e.error.message;
          console.error(e);
          this.msgDialog('ERROR', msg, false, 'E');
        },
      });
    }
  }

  checkPasswords(): void {
    const editingSelf = Number(this.storageService.userId) === Number(this.id);
    this.passwordsDoNotMatch = editingSelf
      ? this.new_password_hash_Input !== this.new_password_hash_Input2
      : false;
  }

  msgDialog(msgShow:string, msg2Show:string, isOK:boolean, type:string){
    this.dialogService.confirmDialog({
      title: 'Usuario',
      message: msgShow,
      message2: msg2Show,
      confirmText: 'OK',
      cancelText: '',
      showConfirmBox: false,
      dialogType: type,
    })
    .subscribe((yes) => {
      if (isOK) {
        setTimeout(() => {
          this.router.navigate(['users']);
        }, 1000);
      }
    });
  }

  EliminarItm(){
    //DELETE
    let msg:string="";
    this.userService.deleteUser(this.id, this.companyId)
    .subscribe({
      next: (res) => {
        msg = res.message;
        console.log(msg);
        this.msgDialog(msg, '', true, 'O');
      },
      error: (e) => {
        msg = e.error.message;
        console.error(e);
        this.msgDialog('ERROR', msg, false, 'E');
      },
    });
  }

  onEliminarItm() {
    this.dialogService.confirmDialog({
      title: this.translocoService.translate('user.msgTitle'),
      message: this.translocoService.translate('user.msgMessage'),
      message2: this.translocoService.translate('user.msgMessage2'),
      confirmText: this.translocoService.translate('user.confirmText'),
      cancelText: this.translocoService.translate('user.cancelText'),
        showConfirmBox: true,
        dialogType: 'A',
    })
    .subscribe((yes) => {
      if (yes) {
        this.EliminarItm();
        console.log('Si Eliminar.');
      }
    });
  }

}
